import React, { FC } from 'react'
import { TrendingChannelItem } from 'api/schedule/trendingChannel.interface'
import { ChannelListItemLink } from 'components/ChannelListItem/ChannelListItemLink'
import styles from './ChannelList.module.scss'
import { ConditionalRender } from 'components/ConditionalRender/ConditionalRender'
import { NativeChannelListItemLink } from 'components/ChannelListItem/NativeChannelListItemLink'

interface Props {
  list: TrendingChannelItem[]
  showBorder?: boolean
  isOnRootOrChildChannel?: boolean
}

export const ChannelList: FC<Props> = ({
  list,
  showBorder = false,
  isOnRootOrChildChannel = false
}) => (
  <div className={styles.ChannelList} data-testid="channel-list">
    {list.map((channel: TrendingChannelItem) => (
      <>
        <ConditionalRender mobileApp={false}>
          <ChannelListItemLink
            key={channel.subdomain}
            channelLogo={channel.logoUrl}
            channelSubdomain={channel.subdomain}
            channelName={channel.name}
            sportLabel={channel.sportName}
            rootDomain={isOnRootOrChildChannel ? '' : channel.rootDomain}
            showBorder={showBorder}
          />
        </ConditionalRender>
        <ConditionalRender web={false}>
          <NativeChannelListItemLink
            key={channel.subdomain}
            channelLogo={channel.logoUrl}
            channelSubdomain={channel.subdomain}
            channelName={channel.name}
            sportLabel={channel.sportName}
            rootDomain={channel.rootDomain}
            showBorder={showBorder}
          />
        </ConditionalRender>
      </>
    ))}
  </div>
)
